/*
  Horelya — ajout au panier en un clic, partagé par tout le thème
  (échantillons et bougie assortie du panier, quiz, bloc « Complétez le rituel »).

  Usage : <button type="button" data-horelya-add="ID_DE_VARIANTE"
                  data-horelya-properties='{"Parfum 1":"Palais Néroli"}'>…</button>
  - data-horelya-properties est facultatif (propriétés de ligne, en JSON).
  Après l'ajout, le panier tiroir de Dawn est rafraîchi et ouvert ; sans tiroir, on va sur /cart.
*/
(function () {
  if (window.horelyaCart) return;

  function add(button) {
    var item = { id: Number(button.dataset.horelyaAdd), quantity: 1 };
    if (button.dataset.horelyaProperties) {
      try { item.properties = JSON.parse(button.dataset.horelyaProperties); } catch (e) { /* propriétés ignorées si JSON invalide */ }
    }
    var drawer = document.querySelector('cart-drawer');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item], sections: 'cart-drawer,cart-icon-bubble' }),
    })
      .then(function (response) { return response.json(); })
      .then(function (json) {
        if (json.status) return;
        if (drawer && drawer.renderContents) drawer.renderContents(json);
        else window.location.href = window.routes.cart_url;
      })
      .finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-horelya-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    add(button);
  });

  window.horelyaCart = { add: add };
})();
